<template>
  <div>
    <div class="row">
      <div class="col-md-3 p-b-0">
        <a
          href="#"
          :class="{ 'text--disabled': prevChannel === -1 }"
          @click.prevent="goToDetails(prevChannel)"
        >
          <i class="mdi mdi-arrow-left p-r-5" />
          prev channel
          <span v-if="prevChannel.name">"{{ prevChannel.name }}"</span>
        </a>
      </div>
      <div class="col-md-6 p-b-0 text-center">
        <h3 class="mb-4">
          <v-avatar
            v-if="channel.logoId"
            tile
          >
            <v-img
              contain
              class="p-r-10"
              :src="'https://playout006.noisypeak.com/api/v1/upload/' + channel.logoId + '?img.crop=30x30'"
              height="30"
            />
          </v-avatar>
          {{ channel.name }}
          <v-menu offset-y>
            <template v-slot:activator="{on, attrs}">
              <v-btn
                fab
                color=""
                small
                depressed
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="openRemoveDialog()">
                <v-icon
                  class="text-body-1 mr-2"
                >
                  mdi-trash-can
                </v-icon>
                <v-list-item-title>
                  Delete
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </h3>
      </div>
      <div class="col-md-3 p-b-0 text-right">
        <a
          href="#"
          :class="{ 'text--disabled': nextChannel === -1 }"
          @click.prevent="goToDetails(nextChannel)"
        >
          next channel
          <span v-if="nextChannel.name">"{{ nextChannel.name }}"</span>
          <i class="mdi mdi-arrow-right p-r-5" />
        </a>
      </div>
    </div>

    <v-tabs
      v-model="tab"
      background-color=""
    >
      <v-tab
        v-for="t in tabs"
        :key="t.name"
      >
        {{ t.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="tab"
      class="transparent"
    >
      <v-tab-item class="transparent">
        <v-row no-gutters>
          <v-col
            cols="12"
            md="12"
            class="d-flex align-center flex-column"
          >
            <video-player
              ref="videoPlayer"
              :src="playerURL"
              @ready="playerReadied"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          />
        </v-row>
        <v-row class="mt-5">
          <v-col
            cols="12"
            md="12"
          >
            <base-card>
              <v-card-text>
                <div
                  class="d-flex align-center flex-wrap mb-2"
                >
                  <v-icon
                    color=""
                    class="pa-1 mr-2"
                  >
                    mdi-link
                  </v-icon>
                  <p class="ma-0">
                    Source URL:
                    <span>
                      <a
                        :href="channel.url"
                        target="_blank"
                        class="ma-0 font-weight-medium"
                      >{{ channel.url }}
                      </a>
                      <v-btn
                        class="m-l-10"
                        x-small
                        icon
                        @click.stop="editURL()"
                      >
                        <v-icon>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="m-l-10"
                        x-small
                        icon
                        @click.stop="handleCopy(channel.streamURL)"
                      >
                        <v-icon>
                          mdi-content-copy
                        </v-icon>
                      </v-btn>
                    </span>
                  </p>
                </div>
                <div
                  class="d-flex align-center flex-wrap mb-2"
                >
                  <v-icon
                    color=""
                    class="pa-1 mr-2"
                  >
                    mdi-link
                  </v-icon>
                  <p class="ma-0">
                    XMLTV URL:
                    <span>
                      <a
                        :href="channel.xmltvURL"
                        target="_blank"
                        class="ma-0 font-weight-medium"
                      >
                        {{ channel.xmltvURL || 'n/a' }}
                      </a>
                      <v-btn
                        class="m-l-10"
                        x-small
                        icon
                        @click.stop="editXMLTVURL()"
                      >
                        <v-icon>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="m-l-10"
                        x-small
                        icon
                        @click.stop="handleCopy(channel.xmltv.resultURLAuto)"
                      >
                        <v-icon>
                          mdi-content-copy
                        </v-icon>
                      </v-btn>
                    </span>
                  </p>
                </div>
                <div
                  class="d-flex align-center flex-wrap mb-2"
                >
                  <v-icon
                    color=""
                    class="pa-1 mr-2"
                  >
                    mdi-attachment
                  </v-icon>
                  <p class="ma-0">
                    Logo and Graphics URL:
                    <span>
                      <a
                        :href="channel.graphicsURL"
                        target="_blank"
                        class="ma-0 font-weight-medium"
                      >
                        {{ channel.graphicsURL || 'n/a' }}
                      </a>
                      <v-btn
                        class="m-l-10"
                        x-small
                        icon
                        @click.stop="editGraphicsURL()"
                      >
                        <v-icon>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </span>
                  </p>
                </div>
                <div
                  class="d-flex align-center flex-wrap mb-2"
                >
                  <v-icon
                    color=""
                    class="pa-1 mr-2"
                  >
                    mdi-monitor
                  </v-icon>
                  <p class="ma-0">
                    Where To View:
                    <span>
                      <a
                        :href="channel.whereToView"
                        target="_blank"
                        class="ma-0 font-weight-medium"
                      >
                        {{ channel.whereToView || 'n/a' }}
                      </a>
                      <v-btn
                        class="m-l-10"
                        x-small
                        icon
                        @click.stop="editWhereToView()"
                      >
                        <v-icon>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </span>
                  </p>
                </div>
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
        <base-card class="mt-5">
          <v-card-text>
            <div class="row">
              <div class="col-md-4 col-12">
                <h5 class="text-18">
                  Short Description
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editShortDescription()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>
                  {{ channel.shortDescription }}<span class="text--disabled" v-if="!channel.shortDescription">N/A</span>
                </p>
                <h5 class="text-18">
                  Long Description
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editLongDescription()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>
                  {{ channel.longDescription }}<span class="text--disabled" v-if="!channel.longDescription">N/A</span>
                </p>
              </div>
              <div class="col-md-7 offset-lg-1 col-12">
                <div class="row no-gutters">
                  <div class="mb-3 col-md-6 col-12">
                    <h5 class="text-18">
                      Name
                      <v-btn
                        small
                        icon
                        class="m-l-5"
                        style="margin-bottom: 3px"
                        color="primary"
                        @click="editName()"
                      >
                        <v-icon size="18">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </h5>
                    <p>{{ channel.name }}</p>
                  </div>
                  <div class="col-md-6 col-12">
                    <h5 class="text-18">
                      Company
                      <v-btn
                        small
                        icon
                        class="m-l-5"
                        style="margin-bottom: 3px"
                        color="primary"
                        @click="editCompany()"
                      >
                        <v-icon size="18">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </h5>
                    <p class="m-b-5">
                      {{ channel.company }}
                    </p>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="mb-3 col-md-6 col-12">
                    <h5 class="text-18">
                      Language
                    </h5>
                    <p>{{ channel.lang }}<span class="text--disabled" v-if="!channel.lang">N/A</span></p>
                  </div>
                  <div class="mb-3 col-md-6 col-12">
                    <h5 class="text-18">
                      Per Deal Approval
                    </h5>
                    <p>{{ channel.perDealApproval }}<span class="text--disabled" v-if="!channel.perDealApproval">N/A</span></p>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col col-6">
                    <h5 class="text-18">
                      Genres
                      <v-btn
                        small
                        icon
                        class="m-l-5"
                        style="margin-bottom: 3px"
                        color="primary"
                        @click="editGenres()"
                      >
                        <v-icon size="18">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </h5>
                    <ul v-if="!channel.genres.length">
                      <li>n/a</li>
                    </ul>
                    <ul v-if="channel.genres.length">
                      <li
                        v-for="genre in channel.genres"
                        :key="genre.id"
                      >
                        {{ genre.name }}
                      </li>
                    </ul>
                  </div>
                  <div class="col col-6">
                    <h5 class="mb-0 text-18">
                      Rating
                    </h5>
                    <p>{{ channel.rating }}<span class="text--disabled" v-if="!channel.rating">N/A</span></p>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </base-card>
        <base-card class="mt-5">
          <v-card-text>
            <div class="row">
              <div class="col-md-3 col-12">
                <h5 class="text-18">
                  Geo Exclusions
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editGeoExclusions()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>{{ channel.geoExclusionsStr }}<span class="text--disabled" v-if="!channel.geoExclusionsStr">N/A</span></p>
              </div>
              <div class="col-md-9 col-12">
                <div class="row no-gutters">
                  <div class="mb-3 col-md-4 col-12">
                    <h5 class="text-18">
                      CCPA US Privacy
                    </h5>
                    <p>{{ channel.USPrivacy }}</p>
                    <h5 class="text-18">
                      Target Package
                    </h5>
                    <p>{{ channel.targetPackage }}<span class="text--disabled" v-if="!channel.targetPackage">N/A</span></p>
                  </div>
                  <div class="col-md-4 col-12">
                    <h5 class="text-18">
                      IAB Category ID
                    </h5>
                    <p>
                      {{ channel.IABCategory }}
                    </p>
                    <h5 class="text-18">
                      COPPA
                      <v-btn
                        small
                        icon
                        class="m-l-5"
                        style="margin-bottom: 3px"
                        color="primary"
                        @click="editCoppa()"
                      >
                        <v-icon size="18">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </h5>
                    <p>{{ channel.coppa }}</p>
                    <h5 class="text-18">
                      Content ID
                      <v-btn
                        small
                        icon
                        class="m-l-5"
                        style="margin-bottom: 3px"
                        color="primary"
                        @click="editContentId()"
                      >
                        <v-icon size="18">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </h5>
                    <p>{{ channel.contentId }}<span class="text--disabled" v-if="!channel.contentId">N/A</span></p>
                  </div>
                  <div class="col-md-4 col-12">
                    <h5 class="text-18">
                      Distribution Logo
                    </h5>
                    <v-img
                      width="200"
                      height="200"
                      contain
                      class="grey darken-4 m-b-0"
                      :src="channel.logoURL ? channel.logoURL : defaultIcon"
                    />
                    <v-file-input
                      v-model="logoFile"
                      class="pointer"
                      placeholder="Upload a new logo (JPEG, PNG)"
                      truncate-length="15"
                      label="File input"
                      style="width: 230px;"
                      show-size
                      accept="image/png, image/jpeg"
                      prepend-icon="mdi-paperclip"
                      :loading="fileLoading"
                      @change="fileUpload()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </base-card>
      </v-tab-item>
      <v-tab-item class="transparent">
        <base-card class="transparent">
          <v-card-text>logos</v-card-text>
        </base-card>
      </v-tab-item>
    </v-tabs-items>

    <!-- Genres Edit Form  -->
    <v-dialog
      v-model="editFormGenres"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Genres</span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="editedGenres"
            :items="genres"
            return-object
            label="Genres"
            item-text="name"
            multiple
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveGenres()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Short Description Edit Form -->
    <v-dialog
      v-model="editFormShortDescription"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Short Description</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model.trim="editedShortDescription"
            append-icon="mdi-comment-text"
            rows="2"
            auto-grow
            counter="140"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveShortDescription()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Long Description Edit Form -->
    <v-dialog
      v-model="editFormLongDescription"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Long Description</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model.trim="editedLongDescription"
            append-icon="mdi-comment-text"
            rows="2"
            auto-grow
            counter="500"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :loading="formLoading"
            class="mr-2"
            @click="saveLongDescription()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Geo Edit Form -->
    <v-dialog
      v-model="editFormGeo"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Geo Exclusions</span>
        </v-card-title>
        <v-card-text>
          <v-col cols="12">
            <v-radio-group
              v-model="denyAll"
              column
              class="p-b-20"
            >
              <v-radio
                label="Only allowed in..."
                color="success darken-3"
                value="1"
              />
              <v-radio
                label="Not in..."
                color="red darken-3"
                value="0"
              />
            </v-radio-group>
            <v-autocomplete
              v-model="selectedLocations"
              :items="locations"
              color="blue-grey lighten-2"
              label="Select countries"
              item-text="name"
              return-object
              multiple
              outlined
              dense
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  label
                  outlined
                  @click="data.select"
                  @click:close="removeLocation(data.item)"
                >
                  <v-avatar left>
                    <v-img :src="'/images/flags/' + data.item.code.toLowerCase() + '.svg'" />
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item" />
                </template>
                <template v-else>
                  <v-list-item-avatar>
                    <img
                      :src="'/images/flags/' + data.item.code.toLowerCase() + '.svg'"
                      alt=""
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name" />
                    <v-list-item-subtitle>
                      <span v-if="data.item.type === 'state'">{{ data.item.code }}</span> {{ data.item.type }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            :loading="formLoading"
            @click="saveGeoExclusions()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- whereToView Edit Form -->
    <v-dialog
      v-model="editFormWhereToView"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Where To View</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="editedWhereToView"
            clearable
            required
            prepend-inner-icon="mdi-link"
            placeholder="http://"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveWhereToView()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- graphicsURL Edit Form -->
    <v-dialog
      v-model="editFormGraphicsURL"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Graphics URL</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="editedGraphicsURL"
            clearable
            required
            prepend-inner-icon="mdi-link"
            placeholder="http://"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveGraphicsURL()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- URL Edit Form -->
    <v-dialog
      v-model="editFormURL"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Source URL</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="editedURL"
            clearable
            required
            prepend-inner-icon="mdi-link"
            placeholder="http://"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveURL()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- XMLTV URL Edit Form -->
    <v-dialog
      v-model="editFormXMLTVURL"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" XMLTV URL</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="editedXMLTVURL"
            clearable
            required
            prepend-inner-icon="mdi-link"
            placeholder="http://"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveXMLTVURL()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Name Form -->
    <v-dialog
      v-model="editFormName"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" name</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="editedName"
            :rules="rules.nameRules"
            :counter="255"
            required
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveName()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Company Form -->
    <v-dialog
      v-model.trim="editFormCompany"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Owner company</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="editedCompany"
            required
            :counter="255"
            outlined
            clearable
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveCompany()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- COPPA  -->
    <v-dialog
      v-model="editFormCoppa"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">COPPA</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editedCoppa"
            required
            type="number"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveCoppa()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Content ID  -->
    <v-dialog
      v-model="editFormContentId"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Content ID</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="editedContentId"
            outlined
            clearable
            required
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            class="mr-2"
            color="primary"
            :loading="formLoading"
            @click="saveContentId()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-sheet class="px-6 py-12">
          <div class="container">
            <div class="d-flex flex-wrap justify-space-between mb-4">
              <v-avatar
                size="120"
                class="mr-6"
              >
                <img
                  class=""
                  :src="channel.logoId ? 'https://playout006.noisypeak.com/api/v1/upload/' + channel.logoId + '?img.crop=120x120' : defaultIcon"
                  alt=""
                >
              </v-avatar>
              <div class="flex-1">
                <div class="d-flex align-start justify-space-between">
                  <div class="mb-3">
                    <h5 class="mr-2 mb-0">
                      {{ channel.name }}
                    </h5>
                    <p class="text--disabled mb-0">
                      {{ channel.company }}
                    </p>
                  </div>
                  <div>
                    <v-chip
                      v-for="genre in channel.genres"
                      :key="genre.id"
                      class="ma-2"
                      :color="randomColor()"
                      outlined
                      small
                    >
                      {{ genre.name }}
                    </v-chip>
                  </div>
                </div>
                <p class="text--disabled">
                  <span class="font-weight-bold">Short description</span>:
                  {{ channel.shortDescription || 'n/a' }}
                </p>
                <p class="text--disabled">
                  <span class="font-weight-bold">Long description</span>:
                  {{ channel.longDescription || 'n/a' }}
                </p>
                <a
                  v-if="channel.url"
                  :href="channel.url"
                  target="_blank"
                  class="ma-0 font-weight-medium"
                >
                  {{ channel.url }}
                </a>
                <v-btn
                  v-if="channel.url"
                  v-clipboard="channel.url"
                  class="m-l-10"
                  icon
                  @click.stop="handleCopy(channel.url)"
                >
                  <v-icon>
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </div>
              <div class="pl-16 text-right">
                <v-btn
                  fab
                  class="mr-2"
                  small
                  depressed
                  @click="openPlayer(channel.url, channel.name)"
                >
                  <v-icon>mdi-play</v-icon>
                </v-btn>
                <v-menu offset-y>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn
                      fab
                      color=""
                      small
                      depressed
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openRemoveDialog()">
                      <v-icon
                        class="text-body-1 mr-2"
                      >
                        mdi-trash-can
                      </v-icon>
                      <v-list-item-title>
                        Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
        </v-sheet>
        <base-card class="transparent">
          <v-tabs
            v-model="tab"
            background-color=""
          >
            <v-tab
              v-for="t in tabs"
              :key="t.name"
            >
              {{ t.name }}
            </v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="tab"
            class="transparent"
          >
            <v-tab-item class="transparent">
              <v-row>
                <v-col cols="12">
                  <base-card>
                    <v-card-text>
                      <v-row>
                        <v-col
                          cols="12"
                          md="8"
                        >
                          <v-text-field
                            v-model="editChannel.name"
                            :rules="rules.nameRules"
                            :counter="255"
                            label="Name*"
                            required
                          />
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="editChannel.company"
                            label="Owner company"
                            required
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </base-card>
                </v-col>
                <v-col cols="12">
                  <base-card>
                    <v-card-text>
                      <v-form
                        ref="form"
                      >
                        <v-text-field
                          v-model="editChannel.url"
                          prepend-icon="mdi-link"
                          label="Source URL*"
                          placeholder="https://"
                          required
                        />

                        <v-textarea
                          v-model="editChannel.shortDescription"
                          label="Short description"
                          rows="1"
                          auto-grow
                        />

                        <v-textarea
                          v-model="editChannel.longDescription"
                          label="Long description"
                          rows="1"
                          auto-grow
                        />
                      </v-form>
                      <v-autocomplete
                        v-model="editChannel.genres"
                        :items="genres"
                        return-object
                        small-chips
                        label="Genres"
                        item-text="name"
                        multiple
                      />
                    </v-card-text>
                  </base-card>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="m-r-20 p-b-20">
                    <v-spacer />
                    <v-btn
                      :loading="saving"
                      :disabled="!isFormValid || saving"
                      color="success"
                      @click="updateChannel()"
                    >
                      <v-icon left>
                        mdi-content-save
                      </v-icon>
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item class="transparent">
              <base-card class="transparent">
                <v-card-text>logos</v-card-text>
              </base-card>
            </v-tab-item>
          </v-tabs-items>
        </base-card>
      </v-col>
    </v-row-->
    <!-- Remove Dialog -->
    <v-dialog
      v-model="removeDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete channel?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the channel "{{ channel.name }}"?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="removeDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteChannel()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { processThirdPartyChannel, processGenre, thirdPartyChannelToJsonAPI } from '@/store/converters'
  import videoPlayer from '@/player/player'
  import Vue from "vue";

  export default {
    components: {
      videoPlayer,
    },
    metaInfo: {
      title: 'Third Party Channel',
    },
    data () {
      return {
        tab: null,
        tabs: [
          { name: 'Basic Info' },
          { name: 'Distributions' },
        ],
        genres: [],
        channels: [],
        channel: {
          id: 0,
          name: '',
          genres: [],
        },
        editChannel: {
          name: '',
          company: '',
          shortDescription: '',
          longDescription: '',
          url: '',
          genres: [],
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 1024) || 'Name must be less than 1024 characters',
          ],
        },
        removeDialog: false,
        saving: false,
        //
        formLoading: false,
        editFormGenres: false,
        editedGenres: [],
        editFormShortDescription: false,
        editedShortDescription: '',
        editFormLongDescription: false,
        editedLongDescription: '',
        editFormGeo: false,
        locations: [],
        selectedLocations: [],
        denyAll: '0',
        editedWhereToView: '',
        editFormWhereToView: false,
        editedGraphicsURL: '',
        editFormGraphicsURL: false,
        editedXMLTVURL: '',
        editFormXMLTVURL: false,
        editedURL: '',
        editFormURL: false,
        editedName: '',
        editFormName: false,
        editedCompany: '',
        editFormCompany: false,
        editedCoppa: 0,
        editFormCoppa: false,
        editedContentId: '',
        editFormContentId: false,
        langs: ['en', 'es', 'pt', 'Hindi', 'French', 'German', 'Italian', 'Japanese', 'Chinese', 'Turkish'],
        playerURL: '',
        logoFile: null,
        fileLoading: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (!(this.editChannel.name.length >= 3 && this.editChannel.name.length <= 255)) {
          return false
        }
        if (!this.editChannel.url.startsWith('http')) {
          return false
        }
        return true
      },
      defaultIcon () {
        return '/images/no_logo.jpeg'
      },
      prevChannel () {
        for (let i = 1; i < this.channels.length; i += 1) {
          if (this.channel.id === this.channels[i].id) {
            return this.channels[i - 1]
          }
        }
        return -1
      },
      nextChannel () {
        for (let i = 0; i < this.channels.length - 1; i += 1) {
          if (this.channel.id === this.channels[i].id) {
            return this.channels[i + 1]
          }
        }
        return -1
      },
    },
    watch: {
      '$route' (to, from) {
        if (to.params.channel_id) {
          this.loadData(to.params.channel_id)
        }
      },
      'playerDialog' (to, from) {
        if (to === false) {
          this.closePlayer()
        }
      },
      tab (newVal) {
        if (newVal == 1) {
          this.player.pause()
        }
      },
    },
    created () {
      this.loadData(this.$route.params.channel_id)
    },
    methods: {
      loadData (channelId) {
        this.$store.commit('setPageLoader')

        const channelArgs = {
          $expand: '*',
        }
        const channelReq = this.$store.dispatch('thirdPartyChannels', channelArgs)

        const genreArgs = {}
        const genreReq = this.$store.dispatch('genres', genreArgs)

        const locationArgs = {
          $orderby: 'name',
        }
        const locationReq = this.$store.dispatch('locations', locationArgs)

        this.setPlayerURL(' ')

        return Promise.all([channelReq, genreReq, locationReq])
          .then((res) => {
            const channels = res[0] || []
            this.channels = channels.map((ch) => processThirdPartyChannel(ch))

            for (let i = 0; i < this.channels.length; i += 1) {
              if (this.channels[i].id == channelId) {
                this.channel = this.channels[i]
                break
              }
            }

            if (this.channel.id === 0) {
              this.$router.push({ name: 'ThirdPartyChannelsPage' })
            }

            this.setPlayerURL(this.channel.url)

            const genres = res[1] || []
            this.genres = genres.map((g) => processGenre(g))

            const locations = res[2] || []
            this.locations = locations

            const locationMap = {}
            for (let i = 0; i < locations.length; i += 1) {
              locationMap[locations[i].id] = locations[i]
            }
            for (let i = 0; i < this.channel.locations.length; i += 1) {
              // eslint-disable-next-line no-prototype-builtins
              if (locationMap.hasOwnProperty(this.channel.locations[i].id)) {
                this.channel.locations[i].name = locationMap[this.channel.locations[i].id].name
                this.channel.locations[i].code = locationMap[this.channel.locations[i].id].code
                this.channel.locations[i].type = locationMap[this.channel.locations[i].id].type
              }
            }
            this.geoExclusionsStr()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'ThirdPartyChannelsPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      geoExclusionsStr () {
        if (!this.channel.locations.length) {
          this.channel.geoExclusionsStr = ''
          return
        }
        let str = 'Only allowed in '
        if (this.channel.denyAll === '0') {
          str = 'Not in '
        }
        const locations = []
        for (let i = 0; i < this.channel.locations.length; i += 1) {
          const l = this.channel.locations[i]
          const title = l.type === 'state' ? l.name + ' ' + l.code : l.name
          locations.push(title)
        }
        str += locations.join(', ')
        this.channel.geoExclusionsStr = str
      },
      updateEditForm (channel) {
        this.editChannel.id = channel.id
        this.editChannel.name = channel.name || ''
        this.editChannel.url = channel.url || ''
        this.editChannel.shortDescription = channel.shortDescription || ''
        this.editChannel.longDescription = channel.longDescription || ''
        this.editChannel.genres = channel.genres
        this.editChannel.company = channel.company || ''
      },
      updateChannelForm (channel) {
        this.channel.name = channel.name || ''
        this.channel.url = channel.url || ''
        this.channel.shortDescription = channel.shortDescription || ''
        this.channel.longDescription = channel.longDescription || ''
        this.channel.genres = channel.genres
        this.channel.company = channel.company || ''
      },
      randomColor () {
        const colors = ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e', '#f48024', '#69d2e7']
        const rndInd = Math.floor(Math.random() * colors.length) + 1
        return colors[rndInd]
      },
      updateChannel () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')

        const updated = thirdPartyChannelToJsonAPI(this.editChannel)

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then((channel) => {
            this.$store.commit('showSnackbar', {
              text: 'The channel has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.updateChannelForm(processThirdPartyChannel(channel))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      openRemoveDialog () {
        this.removeDialog = true
      },
      deleteChannel () {
        this.$store.commit('setPageLoader')
        this.$store.dispatch('deleteThirdPartyChannel', this.channel.id)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The channel has been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.$router.push({ name: 'ThirdPartyChannelsPage' })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      handleCopy (text) {
        this.$store.commit('showSnackbar', {
          text: 'URL has been copied',
          timeout: 6000,
          color: 'success',
        })
      },
      goToDetails (channel) {
        this.$router.push({
          name: 'ThirdPartyChannel',
          params: {
            channel_id: channel.id,
          },
        })
      },
      playerReadied (player) {
        this.player = player
      },
      setPlayerURL (url) {
        this.playerURL = url
      },
      editGraphicsURL () {
        this.editedGraphicsURL = this.channel.graphicsURL
        this.editFormGraphicsURL = true
      },
      editWhereToView () {
        this.editedWhereToView = this.channel.whereToView
        this.editFormWhereToView = true
      },
      editShortDescription () {
        this.editedShortDescription = this.channel.shortDescription
        this.editFormShortDescription = true
      },
      editLongDescription () {
        this.editedLongDescription = this.channel.longDescription
        this.editFormLongDescription = true
      },
      editGenres () {
        this.editedGenres = this.channel.genres
        this.editFormGenres = true
      },
      editGeoExclusions () {
        this.denyAll = this.channel.denyAll || '0'
        this.selectedLocations = this.channel.locations || []
        this.editFormGeo = true
      },
      editURL () {
        this.editedURL = this.channel.url
        this.editFormURL = true
      },
      editXMLTVURL () {
        this.editedXMLTVURL = this.channel.xmltvURL
        this.editFormXMLTVURL = true
      },
      editName () {
        this.editedName = this.channel.name
        this.editFormName = true
      },
      editCompany () {
        this.editedCompany = this.channel.company
        this.editFormCompany = true
      },
      editContentId () {
        this.editedContentId = this.channel.contentId
        this.editFormContentId = true
      },
      editCoppa () {
        this.editedCoppa = this.channel.coppa
        this.editFormCoppa = true
      },
      closeDialog () {
        this.editFormGenres = false
        this.editFormShortDescription = false
        this.editFormLongDescription = false
        this.editFormGeo = false
        this.editFormWhereToView = false
        this.editFormGraphicsURL = false
        this.editFormURL = false
        this.editFormXMLTVURL = false
        this.editFormName = false
        this.editFormCompany = false
        this.editFormCoppa = false
        this.editFormContentId = false
      },
      saveGraphicsURL () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          graphics_url: this.editedGraphicsURL,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Graphics URL has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.graphicsURL = this.editedGraphicsURL
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveWhereToView () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          where_to_view: this.editedWhereToView,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: '"Where To View" field has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.whereToView = this.editedWhereToView
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveShortDescription () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          short_description: this.editedShortDescription,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Short Description has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.shortDescription = this.editedShortDescription
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveLongDescription () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          long_description: this.editedLongDescription,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Long Description has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.longDescription = this.editedLongDescription
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveGenres () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          genres: this.editedGenres,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Genres have been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.genres = this.editedGenres
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      removeLocation (item) {
        let index = 0
        for (let i = 0; i < this.selectedLocations.length; i += 1) {
          if (this.selectedLocations[i].id === item.id) {
            index = i
          }
        }
        if (index >= 0) this.selectedLocations.splice(index, 1)
      },
      saveGeoExclusions () {
        if (this.formLoading) return
        this.formLoading = true

        const rules = []
        if (this.selectedLocations.length) {
          if (this.denyAll === '1') {
            rules.push({
              name: 'deny all',
              allow: false,
              subject_type: 'everyone',
            })
          } else {
            rules.push({
              name: 'allow all',
              allow: true,
              subject_type: 'everyone',
            })
          }
        }
        for (let i = 0; i < this.selectedLocations.length; i += 1) {
          const rule = {
            subject_type: 'location',
            location_id: this.selectedLocations[i].id,
          }
          rule.allow = this.denyAll === '1'
          rules.push(rule)
        }

        const updated = {
          id: this.channel.id,
          geoip_rules: rules,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Geo Exclusions have been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.locations = this.selectedLocations
            this.channel.denyAll = this.denyAll
            this.geoExclusionsStr()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveURL () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          source_url: this.editedURL,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Source URL has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.url = this.editedURL

            this.$store.dispatch('updateThirdPartyChannelDistributions', updated)
              .then(() => {
              })
              .catch((errorMsg) => {
                console.log('', errorMsg)
              })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveXMLTVURL () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          xmltv_url: this.editedXMLTVURL,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'XMLTV URL has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.xmltvURL = this.editedXMLTVURL
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveName () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          name: this.editedName,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Name has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.name = this.editedName
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveCompany () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          company: this.editedCompany,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Company has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.company = this.editedCompany
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveContentId () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          content_id: this.editedContentId || '',
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Content ID has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.contentId = this.editedContentId
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveCoppa () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          coppa: Number(this.editedCoppa) || 0,
        }

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: '"COPPA" field has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.coppa = this.editedCoppa
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      fileUpload () {
        if (!this.logoFile) return
        if (this.fileLoading) return

        this.fileLoading = true

        const file = new FormData()
        file.append('uploadfile', this.logoFile, this.logoFile.name)

        const params = {
          file,
          instanceId: 8,
        }

        this.$store.dispatch('upload', params)
          .then((result) => {
            const resultURL = 'https://playout006.noisypeak.com/api/v1/upload/' + result.id
            Vue.set(this.channel, 'logoURL', resultURL)

            const updated = {
              id: this.channel.id,
              logo_url: resultURL,
            }

            this.$store.dispatch('updateThirdPartyChannel', updated)
              .then(() => {
                this.$store.commit('showSnackbar', {
                  text: 'Logo has been successfully updated',
                  timeout: 3000,
                  color: 'success',
                })
              })
              .catch((errorMsg) => {
                this.$store.commit('showSnackbar', {
                  text: errorMsg,
                  timeout: 6000,
                  color: 'error',
                })
              })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.fileLoading = false
          })
      },
    },
  }
</script>

<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1320px !important;
  }
}
</style>
